(() => {
  const selector = '[data-custom-size-measurements]';

  const syncPanel = (panel) => {
    const productInfo = panel.closest('.product__info-container');
    const picker = productInfo?.querySelector('variant-selects');
    const customSelected = Boolean(
      picker?.querySelector('[data-custom-size-option]:checked, option[data-custom-size-option]:checked')
    );
    const fields = panel.querySelectorAll('[data-custom-size-field]');
    const confirmation = panel.querySelector('[data-custom-size-confirmation]');
    const buyNow = productInfo?.querySelector('[data-editorial-buy-now]');

    panel.hidden = !customSelected;
    fields.forEach((field) => {
      field.disabled = !customSelected;
    });
    if (!customSelected && confirmation) confirmation.hidden = true;
    if (buyNow) {
      buyNow.hidden = customSelected;
      buyNow.disabled = customSelected;
    }
  };

  const initialize = () => {
    document.querySelectorAll(selector).forEach((panel) => {
      if (panel.dataset.customSizeInitialized) return;
      panel.dataset.customSizeInitialized = 'true';
      const productInfo = panel.closest('.product__info-container');
      const picker = productInfo?.querySelector('variant-selects');

      picker?.addEventListener('change', () => syncPanel(panel));
      panel.querySelector('[data-custom-size-save]')?.addEventListener('click', () => {
        const invalidField = Array.from(panel.querySelectorAll('[data-custom-size-field][required]')).find(
          (field) => !field.checkValidity()
        );
        if (invalidField) {
          invalidField.reportValidity();
          return;
        }
        panel.querySelector('[data-custom-size-confirmation]').hidden = false;
      });
      syncPanel(panel);
    });
  };

  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
